import {logbookApi} from "./logbook-api";
import {
  setCurrentCrewFile,
  setExperience,
  setInviteTrip,
  setIsMoreTrips,
  setTripInvitations,
  setTrips
} from "./logbook-actions";
import {profileApi} from "../profile/profile-api";
import {userApi} from "../user/user-api";


export const getTrips = (params) => async (dispatch, getState) => {
  let {roleIds, yachtTypeIds, tidal, dateBefore, dateAfter, countries, offset, limit = 10} = params !== undefined ? params : {}
  let {trips} = getState().logbookReducer
  const response = await logbookApi.getTrips(roleIds, yachtTypeIds, tidal, dateBefore, dateAfter, offset, limit, countries)
  trips = trips !== null ? trips : []
  if(response.data.length > 0) {
    if(response.data.length !== limit) dispatch(setIsMoreTrips(false))
    dispatch(setTrips((response.data.length > 0 || roleIds || yachtTypeIds || tidal !== undefined
      || dateBefore || dateAfter || countries) ? [...{trips: offset ? trips : []}.trips, ...response.data.sort((a, b) => new Date(a.start_date) - new Date(b.start_date))] : null))
  } else {
    dispatch(setIsMoreTrips(false))
  }
}

export const addTrip = (start_date, finish_date, role_id, start_marina_id, finish_marina_id, start_country_id, finish_country_id,
  tidal, night_hours, miles, yacht_id, yacht_type_id, yacht_model_id, operator_id, itinerary,
  description, owner_name, crew_list_file_link, isDraft, days, isAcceptInvitation, isAccepted, voyage_id) => async (dispatch, getState) => {
  let {trips, inviteTrip} = getState().logbookReducer
  const {profile} = getState().userReducer
  const response = await logbookApi.addTrip({
    start_date, finish_date, role_id, start_marina_id, finish_marina_id, start_country_id, finish_country_id,
    tidal, night_hours: night_hours.length > 0 ? night_hours : 0, miles: miles.length > 0 ? miles : 0,
    yacht_id, yacht_type_id, yacht_model_id, operator_id, itinerary,
    description, owner_name, crew_list_file_link, is_draft: isDraft, voyage_id,
    days
  })
  trips = trips !== null ? trips : []
  dispatch(setTrips([...trips, response.data]))
  dispatch(getExperience(profile.id))
  if(isAcceptInvitation) {
    const {user} = getState().userReducer
    const res = await logbookApi.acceptInvitation(response.data.id, inviteTrip.invitation_id, !isAccepted, isAccepted, user.id)
  }
}
export const editTrip = (tripId, start_date, finish_date, role_id, start_marina_id, finish_marina_id, start_country_id, finish_country_id,
                        tidal, night_hours, miles, yacht_id, yacht_type_id, yacht_model_id, operator_id, itinerary,
                        description, owner_name, crew_list_file_link, isDraft, voyage_id, days, isShareChanges) => async (dispatch, getState) => {
  let {trips} = getState().logbookReducer
  const {profile} = getState().userReducer
  const response = await logbookApi.editTrip(tripId, isShareChanges, {
    start_date, finish_date, role_id, start_marina_id, finish_marina_id, start_country_id, finish_country_id,
    tidal, night_hours: `${night_hours}`.length > 0 ? `${night_hours}` : 0,  miles: `${miles}`.length > 0 ? `${miles}` : 0,
    yacht_id, yacht_type_id, yacht_model_id, operator_id, itinerary,
    description, owner_name, crew_list_file_link, is_draft: isDraft, voyage_id,
    days
  })
  trips = trips.map(trip => {
    if(trip.id === tripId) {
      return {...response.data}
    } else {
      return trip
    }
  })
  dispatch(setTrips([...trips]))
  dispatch(getExperience(profile.id))
}

export const deleteTrip = (tripId) => async (dispatch, getState) => {
  const {trips} = getState().logbookReducer
  await logbookApi.deleteTrip(tripId)
  dispatch(setTrips(trips.length === 1 ? null : [...trips.filter(t => t.id !== tripId)]))
}

export const getInvitation = (token) => async (dispatch) => {
  const response = await logbookApi.getInvitation(token)
  dispatch(setInviteTrip(response.data))
}

export const sendLogbook = (body) => async (dispatch) => {
  const response = await logbookApi.sendLogbook(body)
  console.log(response.data)
}

export const getCurrentCrewFile = (id) => async (dispatch) => {
  const response = await userApi.getFile(id)
  const res = await userApi.getFileInfo(id)
  dispatch(setCurrentCrewFile({
    base64: `data:image/png;base64,${Buffer.from(response.data, 'binary').toString('base64')}`,
    fileType: res.data.filename.split('.')[res.data.filename.split('.').length - 1]
  }))
}

export const getTripInvitations = (tripId) => async (dispatch) => {
  const response = await logbookApi.getTripInvitations(tripId, {})
  dispatch(setTripInvitations(response.data))
}

export const getExperience = (profileId) => async (dispatch, getState) => {
  const response = await logbookApi.getExperience(profileId)
  dispatch(setExperience(response.data))
}
